import { Outlet } from 'react-router-dom';
import { HomeHeader } from '../../../components/new/headers/HomeHeader';
import { Footer } from '../../../components/footers/Footer';
import { BlogsHero } from '../../../components/heros/BlogsHero';
import { PageMain } from '../../../components/seo/PageMain';

export function HubLayout() {
  return (
    <div className="w-full overflow-hidden bg-[#F3F4F4]">
      <HomeHeader headerColor="#0D131E" textColor="#ffffff" />
      <PageMain className="contact-page ">
        <BlogsHero />
        <Outlet />
      </PageMain>
      <Footer />
    </div>
  );
}
